import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'
import VModal from 'vue-js-modal'

import App from './App.vue'
import router from './router'
import store from './store'
import axios from './http'
import Loader from '@/components/Loader.vue'
import mixins from './mixins'

import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@/assets/style/main.scss'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(VModal)
Vue.use(VueMeta)
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS,
  router
})
Vue.mixin(mixins)
Vue.component('Loader', Loader)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
